import styled from 'styled-components';

export const WarningStyled = styled.div`
  color: orange;
  border: 1px solid orange;
  padding: 10px;
  border-radius: 4px;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.normal};
  `}
`;

export const PriceWrapperStyled = styled.span`
  ${({ theme }) => `
    font-size: ${theme.fontSizes.large};
  `}
`;
